export const getBase64 = (file: File | Blob): Promise<string | null> => {
  return new Promise<string | null>((resolve) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = () => resolve(null)
  })
}
